module.exports = __webpack_public_path__ + "static/media/ic-crm-feed-posts.2d782aa2.svg";